import React from 'react'
import type { SelectInlineInputProps, SelectOption } from '@ztechapps/webui.input'
import { Select, SelectInlineInput, buildEnumOptions } from '@ztechapps/webui.input'
import { Status, StatusEnum } from '@ztechapps/common.contract'
import { StatusBadge } from '@ztechapps/webui.util'

const getStatusColor = (status: string) => Status[status]?.color ?? '#6c757d'

export const statusOptions = buildEnumOptions(StatusEnum)

export const StatusSelect = ({ ...rest }) => {
  return (
    <Select
      {...{
        ...rest,
        options: statusOptions,
      }}
    />
  )
}

export const StatusSelectInlineInput = (props: SelectInlineInputProps) => {
  return (
    <SelectInlineInput
      {...props}
      selectComponent={StatusSelect}
      selectOptions={statusOptions}
      displayContent={
        props.displayContent ??
        ((option: SelectOption) => <StatusBadge status={option.value} statusColor={getStatusColor(option.value)} />)
      }
    />
  )
}
